import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Button } from 'react-bootstrap';
import Calendar from 'react-calendar';

import TimeSelectorDetail from 'components/ui/form/dates/time/TimeSelectorDetail';

import 'style/components/ui/form/dates/datetime/datetime-selector.scss';

const MIN_DAY = 1, MIN_MONTH = 0, MAX_MONTH = 11;

const
    DATETIME_PANEL_DATE = 1,
    DATETIME_PANEL_TIME = 2;

/** Component to select a month in a table */
class DateTimeSelector extends Component {

    static propTypes = {
        textMenu:     PropTypes.string, // The text to show at the top menu
        defaultValue: PropTypes.number, // Timestamp of the default datetime
        startLimit:   PropTypes.number, // Timestamp of the available start limit date
        endLimit:     PropTypes.number, // Timestamp of the available end limit date
        onChange:     PropTypes.func, // Listener for when the selected month changes
        onClickTitle: PropTypes.func, // Listener for when the title has been clicked
        onClickMenu:  PropTypes.func, // Listener for when any menu button has been clicked
        disabled:     PropTypes.bool, // True when should be disabled
        hideDate:     PropTypes.bool, // True when date picker should be hide
        hideTime:     PropTypes.bool, // True when time picker should be hide
        notClean:     PropTypes.bool // True when the value can not be cleaned
    };

    state = {
        value: undefined, // The current datetime
        panel: DATETIME_PANEL_DATE // The current shown panel
    };

    /**
     * Init the state
     */
    componentWillMount() {
        const {defaultValue, hideDate} = this.props;
        const {panel} = this.state;

        const date = defaultValue && new Date(defaultValue);


        if (date) {
            //date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes()));
        }
        this.setState({
            value: date,
            panel: hideDate ? DATETIME_PANEL_TIME : panel
        });

        this.handleChangeDateTime = this.handleChangeDateTime.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.handleChangeDate = this.handleChangeDate.bind(this);
        this.handleChangeTime = this.handleChangeTime.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    /**
     * Updates the state when the defaultValue has changed
     */
    componentWillReceiveProps(nextProps) {
        const {defaultValue, hideDate} = this.props;
        const {panel} = this.state;

        if (nextProps.defaultValue !== defaultValue) {
            let date = nextProps.defaultValue && new Date(nextProps.defaultValue);


            if (date) {
                date = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes()));
            }
            this.setState({
                value: date
            });
        }

        if (hideDate !== nextProps.hideDate) {
            this.setState({
                panel: nextProps.hideDate ? DATETIME_PANEL_TIME : panel
            });
        }
    }

    /**
     * Toggle the shown panel
     */
    handleChangeDateTime() {
        const {panel} = this.state;

        this.setState({
            panel: panel === DATETIME_PANEL_DATE ? DATETIME_PANEL_TIME : DATETIME_PANEL_DATE
        });
    }

    /**
     * Change the date from the datepicker
     */
    handleChangeDate(newValue) {
        const
            {onChange} = this.props,
            {value} = this.state;

        let date;

        if (value) {
            const diff = value.getTimezoneOffset() - newValue.getTimezoneOffset();

            date = new Date(value);
            date.setFullYear(newValue.getFullYear());
            date.setMonth(newValue.getMonth());
            date.setDate(newValue.getDate());
            date.setMinutes(date.getMinutes() + diff);
        } else {
            date = new Date(Date.UTC(newValue.getFullYear(), newValue.getMonth(), newValue.getDate(), newValue.getHours(), newValue.getMinutes(), newValue.getSeconds(), newValue.getMilliseconds()));
        }

        if (onChange) {
            onChange(date);
        } else {
            this.setState({
                value: date,
                panel: DATETIME_PANEL_TIME
            });
        }
    }

    /**
     * Change the time from the datepicker
     */
    handleChangeTime(newValue) {
        const
            {onChange} = this.props,
            {value} = this.state;

        let date = value;

        if (value) {
            date = new Date(value);
        } else {
            date = new Date();
        }

        date.setHours(newValue.hours);
        date.setMinutes(newValue.minutes);

        if (onChange) {
            onChange(date);
        } else {
            this.setState({
                value: date
            });
        }
    }

    /**
     * Change the time from the datepicker
     */
    handleSubmit() {
        const
            {value} = this.state,
            {onChange} = this.props;

        onChange && onChange(value);
    }

    /**
     * Clear the date
     */
    handleClear() {
        const
            {value} = this.state,
            {onChange} = this.props;

        if (value) {
            if (onChange) {
                onChange(undefined);
            } else {
                this.setState({
                    value: undefined
                });
            }
        }
    }

    /**
     * Creates the array that contains the month data objects
     * @returns {Array} The array with the months
     */
    getMonths() {
        const
            ret = [],
            { intl:{formatDate}} = this.props,
            date = new Date();

        date.setDate(MIN_DAY);
        for (let i = MIN_MONTH; i <= MAX_MONTH; i++) {
            date.setMonth(i);

            ret.push({
                id:   i,
                text: formatDate(date, {month: 'short'})
            });
        }

        return ret;
    }

    renderPanel() {
        const
            {startLimit, endLimit, intl: {locale}, disabled} = this.props,
            {panel, value} = this.state,
            dates = {};

        if (startLimit) {
            dates.minDate = typeof startLimit === 'number' ? new Date(startLimit) : startLimit;
        }
        if (endLimit) {
            dates.maxDate = typeof endLimit === 'number' ? new Date(endLimit) : endLimit;
        }

        switch (panel) {
        case DATETIME_PANEL_DATE:
            return (
                <Calendar
                    value={value}
                    onChange={this.handleChangeDate}
                    locale={locale}
                    disabled={disabled}
                    {...dates}
                />
            );
        case DATETIME_PANEL_TIME:
            return (
                <TimeSelectorDetail
                    value={value ? value.getTime() : undefined}
                    onChange={this.handleChangeTime}
                    onSubmit={this.handleSubmit}
                    disabled={disabled}
                />
            );
        default:
            return null;
        }
    }

    renderValue() {
        const
            datetimeFormatOptions = {},
            {hideDate, hideTime, intl:{formatDate, formatMessage}} = this.props,
            {value} = this.state;
        let labelEmpty = 'label.msg_no_time';


        if (!hideDate) {

            labelEmpty = 'label.msg_no_date';
            datetimeFormatOptions.day = 'numeric';
            datetimeFormatOptions.year = 'numeric';
            datetimeFormatOptions.month = 'long';
        }
        if (!hideTime) {
            datetimeFormatOptions.hour = '2-digit';
            datetimeFormatOptions.minute = '2-digit';
            datetimeFormatOptions.timeZoneName = 'short';
            datetimeFormatOptions.hour12 = false;
        }

        const text = value ? formatDate(value, datetimeFormatOptions) : formatMessage({id: labelEmpty});

        return (
            <div className="datetime-selector-value">
                {text}
            </div>
        );
    }

    renderChangeButton() {
        const {hideDate, hideTime, disabled, intl:{formatMessage}} = this.props,
            {panel} = this.state,
            changeText = panel === DATETIME_PANEL_DATE ? 'changetime' : 'changedate';

        return !hideDate && !hideTime ?
            <Button
                block
                onClick={this.handleChangeDateTime}
                disabled={disabled}
            >
                {formatMessage({id: `label.datepicker.${changeText}`})}
            </Button> :
            null;
    }

    renderClear() {
        const {intl:{formatMessage}, hideDate, notClean, disabled} = this.props;

        return notClean ? null :
            <Button
                block
                onClick={this.handleClear}
                disabled={disabled}
            >
                {formatMessage({id: hideDate ? 'label.timepicker.clear' : 'label.datepicker.clear'})}
            </Button>;
    }

    render() {
        return (
            <div className="datetime-selector">
                {this.renderValue()}
                {this.renderChangeButton()}
                {this.renderPanel()}
                {this.renderClear()}
            </div>
        );
    }
}

export default injectIntl(DateTimeSelector);



// WEBPACK FOOTER //
// ./src/components/ui/form/dates/datetime/DateTimeSelector.jsx